// Filter state lives in the query string so a filtered view is linkable and the
// back button behaves. replaceState is used rather than pushState: typing in the
// search box should not create a history entry per keystroke.

export function readState(keys) {
    const state = {};
    if (typeof window === 'undefined' || !window.location) return state;

    const params = new URLSearchParams(window.location.search);
    for (const key of keys) {
        const value = params.get(key);
        if (value !== null && value !== '') {
            state[key] = value;
        }
    }

    return state;
}

export function writeState(state, defaults) {
    if (typeof window === 'undefined' || !window.history || !window.history.replaceState) return;

    const params = new URLSearchParams(window.location.search);
    for (const key of Object.keys(state)) {
        const value = state[key];
        if (value === undefined || value === null || value === '' || value === defaults[key]) {
            params.delete(key);
        } else {
            params.set(key, value);
        }
    }

    const query = params.toString();
    const url = window.location.pathname + (query ? '?' + query : '') + window.location.hash;
    window.history.replaceState(window.history.state, '', url);
}
